import { compose } from "react-apollo"
import { connect } from "react-redux"
import moment from "moment"
import gql from "graphql-tag"
import { graphqlDynamic } from "react-apollo-dynamic-query"

import { GRAPHQL_DATE_FORMAT } from "../../helpers/sharedConstants"

import UtilizationDetailCards from "."

const generateQuery = ({ entityType, timeslice }) => gql`
  query AssetUtilizationUnitSummary(
    $entityId: ID!
    $deviceTypeId: ID!
    $startAt: String!
    $endAt: String!
    $owningDeptId: ID
  ) {
    entity: ${entityType}(id: $entityId) {
      id
      deviceType(id: $deviceTypeId) {
        utilization(
          startAt: $startAt
          endAt: $endAt
          owningDeptId: $owningDeptId
        ) {
          timeslices {
            ${timeslice}s {
              startsAt
              aggregates {
                maxInEntity {
                  inEntityCount
                }
                peakUtilization {
                  utilizedCount
                }
              }
            }
            full {
              aggregates {
                maxInEntity {
                  inEntityCount
                }
                peakUtilization {
                  availableCount
                }
                averages {
                  utilizedPercentage
                  utilizedCount
                }
              }
            }
          }
        }
      }
    }
  }
`

export default compose(
  connect(({ dateRange: { startDate, endDate } }) => {
    const start = moment(startDate)
    const end = moment(endDate)
    return {
      startDate: start,
      endDate: end,
      timeslice: end.diff(start, "day") > 92 ? "week" : "day", // 3 months will have at most 92 days. If more than 3 months, slice data weekly.
    }
  }),
  graphqlDynamic(generateQuery, {
    skip: ({ loading }) => loading,
    props: ({ data, ownProps }) => {
      if (data.loading) {
        return { loading: true }
      } else if (
        !data.entity.deviceType.utilization.timeslices.full.aggregates
      ) {
        return null
      } else {
        return {
          availableDuringPeak:
            data.entity.deviceType.utilization.timeslices.full.aggregates
              .peakUtilization.availableCount,
          avgUsage:
            data.entity.deviceType.utilization.timeslices.full.aggregates
              .averages.utilizedPercentage,
          maxInEntity:
            data.entity.deviceType.utilization.timeslices.full.aggregates
              .maxInEntity.inEntityCount,
          averageUtilizedCount:
            data.entity.deviceType.utilization.timeslices.full.aggregates
              .averages.utilizedCount,
          peakUsageTrend: data.entity.deviceType.utilization.timeslices[
            `${ownProps.timeslice}s`
          ]
            .map(day => {
              if (day.aggregates) {
                return {
                  startsAt: day.startsAt,
                  period: ownProps.timeslice,
                  // Even though the field below is called "peakUtilizedCount", we actually want the spark lines to be a graph of peak utilized percentages, hence the math.
                  peakUtilizedCount: Math.round(
                    (day.aggregates.peakUtilization.utilizedCount /
                      day.aggregates.maxInEntity.inEntityCount) *
                      100
                  ),
                }
              } else {
                return null
              }
            })
            .filter(day => day != null),
        }
      }
    },
    options: ({
      entityId,
      owningDeptId,
      deviceTypeId,
      startDate,
      endDate,
    }) => ({
      variables: {
        entityId,
        deviceTypeId,
        owningDeptId,
        startAt: startDate.format(GRAPHQL_DATE_FORMAT),
        endAt: endDate.format(GRAPHQL_DATE_FORMAT),
      },
    }),
  })
)(UtilizationDetailCards)
